import { type FC } from 'react';
import { type LessonForStreamDashboard } from 'Lessons';
import { LessonLockedModal } from './LessonLockedModal';
import { NoUserUpsellModal } from './NoUserUpsellModal';
import { TimeLimitModal } from './TimeLimitModal';
import { PrerequisitesNotMetModal } from './PrerequisitesNotMetModal';

/*
    The modals the dashboard can open. Kept together so StreamDashboardPage stays readable, and
    because only one of them is ever open at a time.

    The prerequisites modal is the exception to "opened by something the student did": it opens on
    load and there is no way to dismiss it back onto the page, matching showModalIfPrereqsNotMet.
*/

type Props = {
    brandName: string;
    upsellOpen: boolean;
    onCloseUpsell: () => void;
    lockedMessage: string | null;
    onCloseLocked: () => void;
    pendingTimedLaunch: { lesson: LessonForStreamDashboard; linkId: string } | null;
    timeLimitHours: number | null;
    onConfirmTimedLaunch: () => void;
    onCancelTimedLaunch: () => void;
    prerequisitesNotMet: boolean;
    prerequisitesReasonTitle: string | null;
    prerequisitesReasonMessage: string | null;
    onClosePrerequisites: () => void;
};

export const StreamDashboardModals: FC<Props> = ({
    brandName,
    upsellOpen,
    onCloseUpsell,
    lockedMessage,
    onCloseLocked,
    pendingTimedLaunch,
    timeLimitHours,
    onConfirmTimedLaunch,
    onCancelTimedLaunch,
    prerequisitesNotMet,
    prerequisitesReasonTitle,
    prerequisitesReasonMessage,
    onClosePrerequisites,
}) => (
    <>
        {prerequisitesNotMet && prerequisitesReasonTitle && prerequisitesReasonMessage && (
            <PrerequisitesNotMetModal
                reasonTitle={prerequisitesReasonTitle}
                reasonMessage={prerequisitesReasonMessage}
                onClose={onClosePrerequisites}
            />
        )}

        {upsellOpen && <NoUserUpsellModal brandName={brandName} onClose={onCloseUpsell} />}

        {lockedMessage && <LessonLockedModal reasonMessage={lockedMessage} onClose={onCloseLocked} />}

        {pendingTimedLaunch && timeLimitHours && (
            <TimeLimitModal
                timeLimitHours={timeLimitHours}
                onConfirm={onConfirmTimedLaunch}
                onClose={onCancelTimedLaunch}
            />
        )}
    </>
);
